import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-service-order-tabs',
  templateUrl: './service-order-tabs.component.html',
  styleUrls: ['./service-order-tabs.component.scss']
})
export class ServiceOrderTabsComponent implements OnInit {

  // params
  id: number | string;

  baseRoute = '/sales/service-orders';

  constructor(
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this._route.params.subscribe((params: any) => {
      if (params.id) {
        this.id = params.id;
        this.baseRoute = `${this.baseRoute}/${params.id}`;
      }
    });

  }

}
